import React, { useEffect, useState } from "react";

import { connect } from "react-redux";

import Stack from "@busbud/design-system-components/dist/Stack";
import Text from "@busbud/design-system-components/dist/Text";

import { useAppContext } from "@app/helpers/hooks";
import type { CheckoutReduxState } from "@app/types/checkout-redux-types";
import type { PublicState } from "@app/types/napi-types";

import type { ConnectedProps } from "react-redux";

import { useStyles } from "./processing-payment.styles";
import { PURCHASE_STEPS_NAMES } from "../../../modules/checkout/constants";
import { getPurchaseStepForState } from "../../../modules/checkout/helpers/purchase-steps";
import { AlertDialog } from "../../alert-dialog";
import { LinearProgressBar } from "../../linear-progress-bar";
import { PaymentCardIllustration } from "../illustrations/payment";

interface Props extends ConnectedProps<typeof connector> {}

const ProcessingPaymentComponent: React.FC<Props> = ({
  completed_payment_action = false,
  purchase_state
}: {
  completed_payment_action: boolean;
  purchase_state: PublicState | null;
}) => {
  const [purchase_attempt_is_10s_old, setPurchaseAttempt10sOld] =
    useState(false);
  const { translator } = useAppContext();
  const { classes } = useStyles();

  const long_or_completed =
    purchase_attempt_is_10s_old || completed_payment_action;

  const title = long_or_completed
    ? translator.t("!checkout.purchase-progress.title.completing-booking")
    : translator.t("!checkout.purchase-progress.title.processing-payment");

  const content = long_or_completed
    ? translator.t("!checkout.purchase-progress.message.completing-booking")
    : translator.t("!checkout.purchase-progress.message.please-wait");

  useEffect(() => {
    const timeout = setTimeout(() => setPurchaseAttempt10sOld(true), 10000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const message = (
    <Stack direction="column" alignItems="center" spacing={1}>
      <div>
        <PaymentCardIllustration />
      </div>
      <Text size="lg" align="center">
        {title}
      </Text>
      <Text size="md" align="center">
        {content}
      </Text>

      <LinearProgressBar
        className={classes.gutter}
        initial_value={completed_payment_action ? 0.5 : 0}
        is_completed={
          getPurchaseStepForState(purchase_state) ===
          PURCHASE_STEPS_NAMES.COMPLETED
        }
      />
    </Stack>
  );

  return <AlertDialog title={false} message={message} />;
};

const mapStateToProps = (state: CheckoutReduxState) => {
  const { completed_payment_action, purchase_progress } = state;

  return {
    completed_payment_action,
    purchase_state: purchase_progress.purchase_state
  };
};

const connector = connect(mapStateToProps);

export const ProcessingPayment = connector(ProcessingPaymentComponent);
